import { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./assets/scss/index.scss";
import { initI18n } from "./locals/index";
import App from "./App";
import { SnackbarProvider } from "notistack";
import { SnackbarUtilsConfigurator } from "./components/NotistackPlus";
import { QueryClientProvider, QueryClient } from "@tanstack/react-query";
import { LicenseInfo } from "@mui/x-license-pro";
import { useConfigStore } from "./store/config";
import { useUrfReceiveEvents } from "./hooks/urfEvents";
import Loading from "./components/Loading";

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE_KEY as string);
const queryClient = new QueryClient();

const LanguageGate = () => {
  useUrfReceiveEvents();
  const [language] = useConfigStore((state) => [state.language]);
  const [i18nReady, setI18nReady] = useState(false);

  useEffect(() => {
    if (!language) {
      setI18nReady(false);
      return;
    }
    let cancelled = false;
    setI18nReady(false);
    void initI18n(language).then(() => {
      if (!cancelled) {
        setI18nReady(true);
      }
    });
    return () => {
      cancelled = true;
    };
  }, [language]);

  if (!language) {
    return <Loading open={true} />;
  }
  if (!i18nReady) {
    return <Loading open={true} />;
  }
  return (
    <SnackbarProvider
      maxSnack={2}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <SnackbarUtilsConfigurator />
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </SnackbarProvider>
  );
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(<LanguageGate />);

void import("./reportWebVitals").then(({ default: report }) => {
  report();
});
